import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

const SCOPED_PATHS = ['/v1/vehicles', '/v1/drivers', '/v1/files', '/v1/devices'];

/**
 * Añade `Idempotency-Key` (UUID v4) a los POST de las rutas tenant-scoped que lo requieren.
 * No sobreescribe si el header ya viene seteado (evita duplicar la key en reintentos).
 */
@Injectable({ providedIn: 'root' })
export class IdempotencyInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.method !== 'POST') return next.handle(req);
    if (!SCOPED_PATHS.some((p) => req.url.includes(p))) return next.handle(req);
    if (req.headers.has('Idempotency-Key')) return next.handle(req);

    return next.handle(req.clone({ setHeaders: { 'Idempotency-Key': crypto.randomUUID() } }));
  }
}
